import { Sidebar } from '@carboncopyco/editor-ui';
import { InspectEditIcon, MouseCursorIcon } from '@carboncopyco/icons';
import { IEditActionsType } from '@carboncopyco/types';
import { TextTooltip } from '@carboncopyco/ui';
import { useEditorTools } from '../../context';
import {
  useEditorInspect,
  useEditorLoaded,
} from '../../context/EditorSdkProvider';

export const EditorSidebarInspectButtons = () => {
  const isEditorLoaded = useEditorLoaded();
  const { updateInspectAction, inspectAction } = useEditorInspect();
  const { isOpenAny, closeAll } = useEditorTools();

  const getKeyShortcut = (key: string) => {
    const isMacOS = navigator.userAgent.search('Mac') !== -1;
    return isMacOS ? `(⌥ ⌘ ${key})` : `(Ctrl + Alt + ${key})`;
  };

  return (
    <>
      <Sidebar.Button
        key={IEditActionsType.navigate}
        disabled={!isEditorLoaded}
        aria-label="Select navigate mode"
        onClick={() => {
          closeAll();
          updateInspectAction(IEditActionsType.navigate);
        }}
        selected={inspectAction === IEditActionsType.navigate && !isOpenAny}
        icon={<MouseCursorIcon />}
        tooltipMessage={`Navigate
         ${getKeyShortcut('N')}`}
      />
      <Sidebar.Button
        key={IEditActionsType.inspect}
        disabled={!isEditorLoaded}
        aria-label="Select inspect mode"
        onClick={() => {
          closeAll();
          updateInspectAction(IEditActionsType.inspect);
        }}
        selected={inspectAction === IEditActionsType.inspect && !isOpenAny}
        icon={<InspectEditIcon />}
        tooltipWidth={80}
        tooltipMessage={
          <div>
            <TextTooltip
              label="Edit"
              color="text-ds-natural-50"
            />
            <br />
            <TextTooltip
              label={getKeyShortcut('E')}
              color="text-ds-natural-50"
            />
          </div>
        }
      />
    </>
  );
};
